import { get } from 'lodash';
import {
  REQUEST_GET_PREOPEN_MANAGER_FEE_NOTE,
  REQUEST_SEARCH_PREOPEN_MANAGER_FEE_NOTE,
  SET_FEE_NOTES_GPO,
} from 'containers/PreOpenManagerFeeNote/constants';

export const requestGetPreOpenManagerFeeNote = (
  status: string,
  page: number,
  pageSize: number,
) => ({
  type: REQUEST_GET_PREOPEN_MANAGER_FEE_NOTE,
  status,
  page,
  pageSize,
});

export const setFeeNotesGpo = (feeNotes: any) => {
  return {
    type: SET_FEE_NOTES_GPO,
    data: get(feeNotes, 'feeNotes', []),
  };
};

export const requestSearchPreOpenManagerFeeNote = (searchQuery: any) => ({
  type: REQUEST_SEARCH_PREOPEN_MANAGER_FEE_NOTE,
  searchQuery,
});
